import React from 'react';
import Header from '../../../../components/header/Header';
import logo from '../../assets/fours-fringand-fr__logo-fringand.svg';

type HeaderType = typeof Header;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore exotic component
const HeaderFoursFringand: HeaderType = (props) => (
  <Header {...props} title="" logoIcon={logo} />
);
export default HeaderFoursFringand;
